<template>
     <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>

        <div class="row">
            <div class="col l12 s12">
                <h5>Ocupación por familia PROSIC</h5>
            </div>
        </div>
        <div class="row">
            <div class="col s12 l12 card">

               <div class="row">
                    <div class="col l4 s12 input-field">
                        <inncosys-sucursales-select-name v-model="selectedStore" ></inncosys-sucursales-select-name >
                    </div>
                    <div class="col l4 s12 input-field">
                        <inncosys-date-picker :options="{}" label="Fecha Consulta"  v-model="fechaConsulta"></inncosys-date-picker>
                    </div>
                   <div class="input-field col l4 s12">
                         <inncosys-select v-show="familiasDataSetReady" :data-set-ready="familiasDataSetReady" :multiple="true" :options="{isMultiple:true}" v-model="familiaSeleccionadas" label="Familia" first-option-message="TODAS">

                            <option v-for="familia in familias" v-bind:key="familia" :value="familia">
                                {{familia}}
                            </option>
                        </inncosys-select>
                    </div>
                    
               </div>
               <div class="row">
                    <div class="col l12 s12">
                        <div v-if="loadingResults" class="progress">
                            <div class="indeterminate"></div>
                        </div>
                        <div id="detalleOcupacionStacked">

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </main>
</template>

<script>
import Breadcrumbs from "../../components/commun/Breadcrumbs.vue";

import * as Highcharts from "highcharts";
import SucursalesSelectName from "../../components/commun/SucursalesSelectName.vue";
import Select from "../../components/commun/forms/Select.vue";
import DatePicker from "../../components/commun/forms/DatePicker.vue";
import { kpiOcupacion } from "../../controllers/mantenimiento/ocupacion";
import { db } from "../../main";
//import {restService} from '../../controllers/mantenimiento/ocupacion';
const moment = require("moment");
const ocupacionControllerInstance = new kpiOcupacion();
export default {
  mounted() {},
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSucursalesSelectName: SucursalesSelectName,
    inncosysDatePicker: DatePicker,
    inncosysSelect: Select
  },
  data() {
    return {
      pathHistory: [
        { name: "Inicio", route: "/" },
        {
          name: "Reportes Directivos",
          route: "/reportes-directivos/ocupacion"
        },
        {
          name: "Ocupación por Familia",
          route: "/reportes-directivos/ocupacion-familia"
        }
      ],
      fechaConsulta: null,
      selectedStore: "",
      loadingResults: false,
      familiasDataSetReady: false,
      familiaSeleccionadas: [],
      familias: [],
      familiasCounters: {},
      equiposPorFamilia: []
    };
  },
  methods: {
    getOcupacionFamilia(sucursal, fecha) {
      console.log("excecuted", sucursal, fecha);
      this.loadingResults = true;
      this.familiasDataSetReady=false;
      const vueInstance = this;
      this.familias=[];
      this.familiaSeleccionadas=[];
      db.ref("data")
        .child("ocupacion")
        .child(this.selectedStore)
        .child(moment.utc(moment(fecha).format("YYYY-MM-DD")).valueOf() + "")
        .once("value")
        .then(familiasSnapshot => {
          if (familiasSnapshot.hasChildren()) {
            ocupacionControllerInstance
              .getFamilias(familiasSnapshot.val())
              .then(familias => {
                vueInstance.familias = Object.keys(familias);
                vueInstance.familiasDataSetReady = true;
                vueInstance.familiaSeleccionadas = vueInstance.familias;
                vueInstance.familiasCounters = familias;
                Object.keys(vueInstance.familiasCounters).forEach(familia => {
                  vueInstance.familiasCounters[familia].totalOcupado =
                    vueInstance.familiasCounters[familia].rentado +
                    vueInstance.familiasCounters[familia].rentado_servicio +
                    vueInstance.familiasCounters[familia].entrega;
                  vueInstance.familiasCounters[familia].total =
                    vueInstance.familiasCounters[familia].totalOcupado +
                    vueInstance.familiasCounters[familia].disponible +
                    vueInstance.familiasCounters[familia].recoger +
                    vueInstance.familiasCounters[familia].servicio +
                    vueInstance.familiasCounters[familia].servicio_taller;
                  vueInstance.familiasCounters[familia].porcentajeOcupacion =
                    vueInstance.familiasCounters[familia].totalOcupado /
                    vueInstance.familiasCounters[familia].total;
                  vueInstance.familiasCounters[familia].totalServicio =
                    vueInstance.familiasCounters[familia].servicio_taller +
                    vueInstance.familiasCounters[familia].recoger;
                });
                vueInstance.familiaSeleccionadas.sort(
                  (familiaA, familiaB) =>
                    vueInstance.familiasCounters[familiaB].porcentajeOcupacion -
                    vueInstance.familiasCounters[familiaA].porcentajeOcupacion
                );

                vueInstance.plotChart();
              });
          } else {
            this.loadingResults = false;
            M.toast({ html: "No se han encontrado datos" });
          }
        });
    },
    plotChart() {
      const series = [
        {
          name: "Disponible",
          color: "#1565c0",
          count: Array(this.familiaSeleccionadas.length + 1)
            .join("0")
            .split("")
            .map(parseFloat),
          data: new Array(this.familiaSeleccionadas.length)
        },
        {
          name: "Servicio",
          color: "#b71c1c",
          count: Array(this.familiaSeleccionadas.length + 1)
            .join("0")
            .split("")
            .map(parseFloat),
          data: new Array(this.familiaSeleccionadas.length)
        },
        {
          name: "Rentado",
          color: "#1b5e20",
          count: Array(this.familiaSeleccionadas.length + 1)
            .join("0")
            .split("")
            .map(parseFloat),
          data: new Array(this.familiaSeleccionadas.length)
        }
      ];
      let indexFamilia = -1;
      this.familiaSeleccionadas.forEach(familia => {
        indexFamilia++;
        series[2].count[indexFamilia] = this.familiasCounters[
          familia
        ].totalOcupado;
        series[1].count[indexFamilia] = this.familiasCounters[
          familia
        ].totalServicio;
        series[0].count[indexFamilia] = this.familiasCounters[
          familia
        ].disponible;
        const totalEquiposFamilia = this.familiasCounters[familia].total;
        // porcentaje ocupacion = countEquipos*totalEquipos/100
        series[0].data[indexFamilia] = {
          y: parseFloat(
            (
              (series[0].count[indexFamilia] * 100) /
              totalEquiposFamilia
            ).toFixed(2)
          ),
          name: this.familiaSeleccionadas[indexFamilia],
          z: series[0].count[indexFamilia],
          totalEquipos: totalEquiposFamilia
        };
        series[1].data[indexFamilia] = {
          y: parseFloat(
            (
              (series[1].count[indexFamilia] * 100) /
              totalEquiposFamilia
            ).toFixed(2)
          ),
          name: this.familiaSeleccionadas[indexFamilia],
          z: series[1].count[indexFamilia],
          totalEquipos: totalEquiposFamilia
        };
        series[2].data[indexFamilia] = {
          y: parseFloat(
            (
              (series[2].count[indexFamilia] * 100) /
              totalEquiposFamilia
            ).toFixed(2)
          ),
          name: this.familiaSeleccionadas[indexFamilia],
          z: series[2].count[indexFamilia],
          totalEquipos: totalEquiposFamilia
        };
      });
      this.loadingResults = false;
      this.equiposPorFamilia = series;
      const vueInstance = this;
      Highcharts.chart("detalleOcupacionStacked", {
        chart: {
          type: "bar",
          height: this.familiaSeleccionadas.length * 45 + 120
        },
        title: {
          text: "Ocupación por familia"
        },
        xAxis: {
          categories: this.familiaSeleccionadas
        },
        yAxis: {
          min: 0,
          opposite: true,
          max: 100,
          title: {
            text: "Ocupación"
          },
          stackLabels: {
            enabled: true
          }
        },

        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            "{series.name}: {point.z}<br/>Total: {point.totalEquipos}"
        },
        plotOptions: {
          series: {
            stacking: "normal",
            dataLabels: {
              enabled: true
            }
          }
        },
        series: this.equiposPorFamilia
      });
      console.log(Highcharts);
    }
  },
  watch: {
    fechaConsulta(value) {
      if (this.selectedStore != null) {
        this.getOcupacionFamilia(this.selectedStore, value);
      }
    },
    selectedStore(value) {
      if (this.fechaConsulta != null) {
        this.getOcupacionFamilia(this.selectedStore, this.fechaConsulta);
      }
    },
    familiaSeleccionadas(value) {
      if (this.familiaSeleccionadas != null && this.familiaSeleccionadas.length > 0) this.plotChart();
    }
  }
};
</script>
<style>
#detalleOcupacionStacked {
  width: 100%;
}
</style>
